<template>
  <div >
    <!-- <index-view></index-view> -->
   <!-- <his-view></his-view> -->
   <!-- <page-view-1></page-view-1> -->
   <!-- <page-view-2></page-view-2> -->
    <router-view></router-view>
    <!-- <operation-view></operation-view> -->
  </div>
</template>

<style>

</style>
<script>
// import OperationView from './views/Operationlog/OperationView.vue'
// import PageView1 from './views/page/PageView1.vue'
// import PageView2 from './views/page/PageView2.vue'
// import IndexView from './views/login/IndexView.vue';
// import HisView from './views/page/HisView.vue';
export default {
  // components: { OperationView },
  data() {
    return {
      
    }
  }
}
</script>
